import React from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Business from "@material-ui/icons/Business";
import {NavLink} from 'react-router-dom';
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import ClinicTimings from "components/Forms/ClinicForm/addTimings.jsx";
// style for this view
import validationFormsStyle from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle.jsx";
import api from '../../../api/Api';
import {
    verifyEmail,
    verifyName
    , verifyUrl,
    verifyNumber, dashboardRouter
} from '../../../util/globalHelper'
import TagsInput from "react-tagsinput";
import InputAdornment from "@material-ui/core/InputAdornment";

class ValidationForms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tags: [],
            clinic_master_id: "",
            // validation

            name: "",
            nameState: "",
            website: "",
            websiteState: "",
            description: "",
            descriptionState: "",

        };
        this.hideAlert = this.hideAlert.bind(this);
        this.typeClick = this.typeClick.bind(this);
        this.CreateAlert = this.CreateAlert.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);

    }


    componentDidMount() {
        // isClinicMasterOrClinic() === "" ? api.listClinicMaster().then(json => {
        //     this.setState({clinicMasterList: json.data.data})
        // }) : this.setState({clinicMasterList: {}, clinic_master_id: clinicmaster_id()});
        // this.props.id.match.params.clinicmasterID ? this.setState({clinic_master_id: this.props.id.match.params.clinicmasterID}) :
        //     this.setState({showDropdown: true})

    }

    componentDidUpdate() {

    }


    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    handleChangeCategories(tags) {
        this.setState({
            tags: tags.filter((v, i, a) => {
                return a.indexOf(v) === i
            })
        })
    }

    handleChangeServices(services) {
        this.setState({
            services: services.filter((v, i, a) => {
                return a.indexOf(v) === i
            })
        });
    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    change(event, stateName, type, inputType, maxValue) {
        this.setState({[stateName]: event.target.value});
        switch (type) {
            case "email":
                if (verifyEmail(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "url":
                if (verifyUrl(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "name":
                if (verifyName(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "number":
                if (verifyNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "novalidation":
                if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else if (event.target.value === "" && inputType === "required") {
                    this.setState({[stateName + "State"]: "error"});
                } else {
                    this.setState({[stateName + "State"]: "success"});
                }
                break;
            default:
                break;
        }
    }

    hideAlert() {
        this.setState({
            alert: null
        });
    }

    CreateAlert() {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title"><ClinicTimings
                        generateNotification={this.props.id.generateNotification.bind(this)}
                        handleTimings={this.handleTimings.bind(this)}
                        hideAlert={this.hideAlert.bind(this)}/></DialogTitle>
                </Dialog>
            )
        });
    }


    typeClick() {
        if (this.state.name === "") {
            this.props.id.generateNotification({message: "Please fill the name!", color: "danger"});
            this.setState({nameState: "error"});

        } else if (this.state.descriptionState === "") {
            this.setState({descriptionState: "error"});
            this.props.id.generateNotification({message: "Please fill the description!", color: "danger"});

        } else if (this.state.nameState === "success" && this.state.descriptionState !== "error") {
            var data = {
                title: this.state.name,
                text: this.state.description,
                tags: this.state.tags,
                meta_data: {
                    external_link: "https://" + this.state.website,
                    images: []
                }
            };
            this.CallCreateApi(data);
        } else {
            var msgcolor = {message: "Some fields are empty!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        }
    }

    handleDescriptionChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    CallCreateApi(data) {
        api.createNotification(data)
            .then(json => {
                if (json.data.status === "failed") {
                    var msgcolor = {message: json.data.reason, color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                } else {
                    var msgcolor = {message: "Notification Added Successfully!", color: "success"};
                    this.props.id.generateNotification(msgcolor);
                    this.props.id.history.push(dashboardRouter("/marketing/notification/list"))
                }
            }).catch(error => {
            var msgcolor = {message: "Server error!", color: "success"};
            this.props.id.generateNotification(msgcolor);
        })
    }


    render() {
        const {classes} = this.props;
        return (
            <div>
                {/*{this.state.alert}*/}
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="info" icon>
                                <CardIcon color="info">
                                    <GridContainer>
                                        <GridItem>
                                            <Business/>
                                        </GridItem>
                                        <GridItem style={{marginTop: 5}}>
                                            <h4 className={classes.cardTitle}>Add Notification</h4>
                                        </GridItem>
                                    </GridContainer>
                                </CardIcon>
                            </CardHeader>
                            <CardBody>
                                <form>
                                    <GridContainer className={classes.justifyContentCenter}>
                                        <GridItem xs={12} sm={4} md={4}>
                                            <CustomInput
                                                labelText="Title"
                                                id="name"
                                                success={this.state.nameState === "success"}
                                                error={this.state.nameState === "error"}
                                                formControlProps={{
                                                    fullWidth: true,
                                                    required: true
                                                }}
                                                inputProps={{
                                                    onChange: event =>
                                                        this.change(event, "name", "name", "required")
                                                }}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer className={classes.justifyContentCenter}>

                                        <GridItem xs={12} sm={4} md={4}>
                                            <CustomInput
                                                success={this.state.descriptionState === "success"}
                                                error={this.state.descriptionState === "error"}
                                                labelText="Description "
                                                id="description"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    onChange: event =>
                                                        this.change(event, "description", "name", "required")
                                                }}
                                            />
                                        </GridItem>
                                    </GridContainer>

                                    <GridContainer>
                                        <GridContainer className={classes.justifyContentCenter}>

                                            <GridItem xs={12} sm={4} md={4}>
                                                {/*<h6>Tags</h6>*/}
                                                {/*<br/>*/}
                                                <TagsInput
                                                    value={this.state.tags}
                                                    onChange={this.handleChangeCategories.bind(this)}
                                                    // tagProps={{className: "react-tagsinput-tag warning"}}
                                                    inputProps={{placeholder: "Tags"}}
                                                />


                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer className={classes.justifyContentCenter}>


                                            <GridItem xs={12} sm={4} md={4}>
                                                <CustomInput
                                                    labelText="Website"
                                                    success={this.state.websiteState === "success"}
                                                    error={this.state.websiteState === "error"}
                                                    id="phonenumber"
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "website", "url", "optional"),
                                                        startAdornment: (
                                                            <InputAdornment position="start">https://</InputAdornment>)
                                                    }}
                                                />

                                            </GridItem>
                                        </GridContainer>


                                    </GridContainer>
                                </form>
                            </CardBody>
                            <CardFooter>
                                <GridContainer className={classes.justifyContentCenter}>
                                    <GridItem xs={12} sm={2}>
                                        <Button block size="lg" color="warning" onClick={this.typeClick}>
                                            Save
                                        </Button>
                                    </GridItem>
                                    <GridItem xs={12} sm={2}>
                                        <NavLink to={dashboardRouter("/marketing/notification/list")}>

                                            <Button block size="lg" color="grey">
                                                Cancel
                                            </Button></NavLink>
                                        <br/>
                                    </GridItem>
                                </GridContainer>
                            </CardFooter>
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
        );
    }

}

export default withStyles(validationFormsStyle, extendedFormsStyle, customInputStyle)(ValidationForms);



// WEBPACK FOOTER //
// ./src/components/Forms/NotificationForm/NotifcationForm.jsx